import React from "react";
import { OnboardingReportsList } from "../components/OnboardingReportsList";

const OnboardingReportsPage = () => {
  return <OnboardingReportsList />;
};

export default OnboardingReportsPage;
